import { DropDownList } from '@syncfusion/ej2-dropdowns';
/**
 * `DropDownList renderer` module is used to render DropDownList in BlockEditor.
 *
 * @hidden
 */
var DropDownListRenderer = /** @class */ (function () {
    function DropDownListRenderer(editor) {
        this.editor = editor;
    }
    /**
     * Renders DropDownList in BlockEditor.
     *
     * @param {IDropDownListRenderOptions} args - specifies  the arguments.
     * @returns {DropDownList} - returns the DropDownList object.
     * @hidden
     */
    DropDownListRenderer.prototype.renderDropDownList = function (args) {
        return new DropDownList({
            dataSource: args.dataSource,
            fields: args.fields,
            value: args.value,
            change: args.change,
            locale: this.editor.locale,
            cssClass: this.editor.cssClass,
            enableRtl: this.editor.enableRtl,
            enablePersistence: this.editor.enablePersistence
        }, args.targetElement);
    };
    return DropDownListRenderer;
}());
export { DropDownListRenderer };
